import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";

import ManuscriptContentView from "./ManuscriptContentView";
import ManuscriptProperties from "./ManuscriptProperties";

/**
 * Import Simple text editor styles
 */
import "./ManuscriptEditor.css";

/**
 * ManuscriptEditor : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Editor for manuscript documents and their
 * content blocks
 */
class ManuscriptEditor extends Component {
  constructor(props) {
    super(props);
    this.state = this.translateFileContentIntoState();
  }

  state = {
    /**
     * isPreviewMode: Boolean
     * True if the editor is set to preview mode.
     */
    isPreviewMode: true
  };

  /**
   * componentDidUpdate: ()
   * Updates file content if current document changes.
   */
  componentDidUpdate() {
    if (this.props.file.id !== this.state.currentFileIdentifier) {
      this.setState(this.translateFileContentIntoState());
    }
  }

  /**
   * onUpdateDocument = content => ()
   * Updates the current document with any changes.
   */
  onUpdateDocument = content => {
    const { file } = this.props;
    const reference = this;

    this.setState(
      {
        currentFileContent: content
      },
      () => {
        const document = file;

        if (!document.content) document.content = {};
        document.content.items = reference.state.currentFileContent;

        this.props.updateDocument(document);
      }
    );
  };

  /**
   * setPreviewMode = enabled => ()
   * Sets whether the editor is in preview mode.
   */
  setPreviewMode = enabled => {
    this.setState({
      isPreviewMode: enabled
    });
  };

  /**
   * canEditDocument = () => Boolean
   * Returns true if the user can edit the document.
   */
  canEditDocument = () =>
    !this.state.isPreviewMode && !this.props.isReadOnlyMode;

  /**
   * translateFileContentIntoState = () => Object
   * Returns a new state object based on the current file.
   */
  translateFileContentIntoState = () => ({
    currentFileContent: this.readFileContent(),
    currentFileIdentifier: this.props.file.id,

    isPreviewMode: true
  });

  /**
   * readFileContent = () => Array
   * Reads the contents of the current file and returns an array
   * of its items.
   */
  readFileContent = () => {
    if (
      this.props.file &&
      this.props.file.content &&
      this.props.file.content.items
    ) {
      return this.props.file.content.items;
    }
    return [];
  };

  /**
   * render()
   * Renders the editor component.
   */
  render() {
    return (
      <div className="ed-editor-view ed-editor-manuscript">
        <div className="ed-editor-content">
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <ManuscriptContentView
                  contentBlocks={this.state.currentFileContent}
                  updateDocument={this.onUpdateDocument}
                  isReadOnlyMode={!this.canEditDocument()}
                />
              </Grid.Column>
              <Grid.Column width={4} className="ed-sidebar">
                <ManuscriptProperties
                  isReadOnlyMode={!this.canEditDocument()}
                  setPreviewMode={this.setPreviewMode}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    );
  }
}

ManuscriptEditor.propTypes = {
  /**
   * Currently open file in editor
   */
  file: PropTypes.shape({
    content: PropTypes.shape({
      items: PropTypes.array
    }),
    id: PropTypes.string
  }),
  /**
   * Function to update and save document
   */
  updateDocument: PropTypes.func.isRequired,
  /**
   * True if the editor should not permit any changes
   */
  isReadOnlyMode: PropTypes.bool
};

ManuscriptEditor.defaultProps = {
  file: {
    content: { items: [] },
    id: ""
  },
  isReadOnlyMode: false
};

export default ManuscriptEditor;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/ManuscriptEditor.js